<template>
  <dl
    class="bg-blue-box mt10"
    :class="{'is-open':isOpenWorkLocation}"
  >
    <template v-if="isBulkRegistrationAddress">
      <dt>勤務地一覧</dt>
      <dd
        class="pega-pre-wrap pega-preview-word-break"
        v-text="valueBulkPlace"
      />
    </template>
    <template v-else>
      <dt>勤務地エリア</dt>
      <dd
        id="work-location"
        :class="{'shorten': shorten}"
        data-test="workLocation"
        v-text="workLocation"
      />
      <div
        v-if="showToggleButton"
        id="job-location-accordion"
        style="display: block;"
      >
        <p @click="togglePlaceText">
          {{ buttonText }}
        </p>
      </div>
    </template>
  </dl>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
export default {
  props: {
    workLocation: {
      type: String,
      default: ''
    },
    isBulkRegistrationAddress: {
      type: Boolean,
      default: false
    },
    valueBulkPlace: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      locationTextHeight: 0,
      isOpenWorkLocation: false
    }
  },
  computed: {
    showToggleButton () {
      return this.locationTextHeight > 38
    },
    buttonText () {
      return this.isOpenWorkLocation ? '勤務地エリアを閉じる' : '勤務地エリアをすべて見る'
    },
    shorten () {
      return this.showToggleButton && !this.isOpenWorkLocation
    }
  },
  mounted () {
    const workLocation = document.getElementById('work-location')
    if (workLocation) { this.$set(this, 'locationTextHeight', document.getElementById('work-location').offsetHeight) }
  },
  methods: {
    togglePlaceText () {
      this.$set(this, 'isOpenWorkLocation', !this.isOpenWorkLocation)
    }
  }
}
</script>
